import React, { useContext, useEffect, useRef, useMemo } from 'react';
import { Menubar } from 'primereact/menubar';
import Search from "./Search";
import { NavLink, useNavigate } from "react-router-dom";
import { getTenantPath } from "../pages/Global/TenantPath";
import { OverlayPanel } from "primereact/overlaypanel";
import './Nav.css';
import { Image } from "primereact/image";
import useHasRole from "../hooks/validRolesHook";
import { UserPermissionsContext } from "../contexts/userPermissionsContext";
import { useValidateAccount } from '../state/accountState';
interface Item {
    label: string;
    items?: Item[];
    command?: () => void;
}

export default function Nav() {
    const navigate = useNavigate()
    // Builds an absolute path using the account name stored by
    // AccountResolver (sessionStorage) — NOT the live URL — so navigation
    // stays correct even if an earlier bug put a wrong value in the URL.
    const goTo = (path: string) => {
        navigate(getTenantPath(path));
    };
    const notificationOverlayRef = useRef(null);
    const [adminItems, setAdminItems] = React.useState<Item[]>();

    const { validRoles } = useContext(UserPermissionsContext);
const { accountName, logoImage } = useValidateAccount(); // your existing hook around ValidateAccount

    const isSysAdmin = useHasRole([
        'System Administrator'
    ]).hasRoles

    const isAccountAdmin = useHasRole([
        'Account Administrator'
    ]).hasRoles

    const isAccountManager = useHasRole([
        'Account Manager'
    ]).hasRoles

    const isQCAdmin = useHasRole([
        'QC Admin'
    ]).hasRoles

    const isQCManager = useHasRole([
        'QC Manager'
    ]).hasRoles

    const isQCAuditor = useHasRole([
        'QC Auditor'
    ]).hasRoles

    const isQCValidator = useHasRole([
        'QC Validator'
    ]).hasRoles

    const isMasterAdmin = useHasRole([
        'Master Administrator'
    ]).hasRoles

    const isSecurityAdmin = useHasRole([
        'Security Administrator'
    ]).hasRoles

    useEffect(() => {
        if (isSysAdmin) {
            setAdminItems([
                {
                    label: "Dashboard", command: () => {
                        goTo('.')
                    }
                },
                {
                    label: "My Work Pages",
                    items: [
                        {
                            label: "QC Work", command: () => {
                                goTo('worklist')
                            }
                        },
                        {
                            label: "Validation Work", command: () => {
                                goTo('Validations')
                            }
                        },
                    ]

                },
                {
                    label: 'File Upload', command: () => {
                        goTo('upload')
                    }
                },
                {
                    label: 'Audits',
                    items: [
                        {
                            label: "Prefund Audits", command: () => {
                                goTo('prefund-qc-audits')
                            }
                        },
                        {
                            label: "Post Close Audits", command: () => {
                                goTo('post-close-qc-audits')
                            }
                        },
                        {
                            label: "Servicing Audits", command: () => {
                                goTo('service-audits')
                            }
                        },
                        {
                            label: "Findings", command: () => {
                                goTo('FindingList')
                            }
                        }
                    ]
                },
                {
                    label: 'QC Reporting', command: () => {
                        goTo('reporting')
                    }
                },
                {
                    label: 'QC Checklist', command: () => {
                        goTo('checklist')
                    }
                },
                {
                    label: 'Admin',
                    items: [
                        {
                            label: "Users", command: () => {
                                goTo('users')
                            }
                        },
                        {
                            label: "Accounts", command: () => {
                                goTo('accounts')
                            }
                        },
                        {
                            label: "Client Banks", command: () => {
                                goTo('clientbanks')
                            }
                        },
                    ]
                }
            ]);
        }
        else if (isAccountAdmin) {
            setAdminItems([
                {
                    label: "Dashboard", command: () => {
                        goTo('.')
                    }
                },
                {
                    label: "QC Work", command: () => {
                        goTo('worklist')
                    }
                },
                {
                    label: 'File Upload', command: () => {
                        goTo('upload')
                    }
                },
                {
                    label: 'Audits',
                    items: [
                        {
                            label: "Prefund Audits", command: () => {
                                goTo('prefund-qc-audits')
                            }
                        },
                        {
                            label: "Post Close Audits", command: () => {
                                goTo('post-close-qc-audits')
                            }
                        },
                        {
                            label: "Servicing Audits", command: () => {
                                goTo('service-audits')
                            }
                        },
                        {
                            label: "Findings", command: () => {
                                goTo('FindingList')
                            }
                        }
                    ]
                },
                {
                    label: 'QC Reporting', command: () => {
                        goTo('reporting')
                    }
                },
                {
                    label: 'QC Checklist', command: () => {
                        goTo('checklist')
                    }
                },
                {
                    label: 'Admin',
                    items: [
                        {
                            label: "Users", command: () => {
                                goTo('users')
                            }
                        },
                        {
                            label: "Client Banks", command: () => {
                                goTo('clientbanks')
                            }
                        },
                    ]
                }
            ]);
        }
        else if (isAccountManager) {
            setAdminItems([
                {
                    label: "Dashboard", command: () => {
                        goTo('.')
                    }
                },
                {
                    label: "QC Work", command: () => {
                        goTo('worklist')
                    }
                },
                {
                    label: 'File Upload', command: () => {
                        goTo('upload')
                    }
                },
                {
                    label: 'Audits',
                    items: [
                        {
                            label: "Prefund Audits", command: () => {
                                goTo('prefund-qc-audits')
                            }
                        },
                        {
                            label: "Post Close Audits", command: () => {
                                goTo('post-close-qc-audits')
                            }
                        },
                        {
                            label: "Servicing Audits", command: () => {
                                goTo('service-audits')
                            }
                        },
                        {
                            label: "Findings", command: () => {
                                goTo('FindingList')
                            }
                        }
                    ]
                },
                {
                    label: 'QC Reporting', command: () => {
                        goTo('reporting')
                    }
                },
                {
                    label: 'QC Checklist', command: () => {
                        goTo('checklist')
                    }
                },
                {
                    label: 'Admin',
                    items: [
                        {
                            label: "Users", command: () => {
                                goTo('users')
                            }
                        },
                        {
                            label: "Client Banks", command: () => {
                                goTo('clientbanks')
                            }
                        },
                    ]
                }
            ]);
        }
        else if (isQCAdmin) {
            setAdminItems([
                {
                    label: "Dashboard", command: () => {
                        goTo('.')
                    }
                },
                {
                    label: "My Work Pages",
                    items: [
                        {
                            label: "QC Work", command: () => {
                                goTo('worklist')
                            }
                        },
                        {
                            label: "Validation Work", command: () => {
                                goTo('Validations')
                            }
                        },
                    ]

                },
                {
                    label: 'File Upload', command: () => {
                        goTo('upload')
                    }
                },
                {
                    label: 'Audits',
                    items: [
                        {
                            label: "Prefund Audits", command: () => {
                                goTo('prefund-qc-audits')
                            }
                        },
                        {
                            label: "Post Close Audits", command: () => {
                                goTo('post-close-qc-audits')
                            }
                        },
                        {
                            label: "Servicing Audits", command: () => {
                                goTo('service-audits')
                            }
                        },
                        {
                            label: "Findings", command: () => {
                                goTo('FindingList')
                            }
                        }
                    ]
                },
                {
                    label: 'QC Reporting', command: () => {
                        goTo('reporting')
                    }
                },
                 {
                     label: 'QC Checklist', command: () => {
                         goTo('checklist')
                    }
                 },
            ]);
        }
        else if (isQCManager) {
            setAdminItems([
                {
                    label: "Dashboard", command: () => {
                        goTo('.')
                    }
                },
                {
                    label: "QC Work", command: () => {
                        goTo('worklist')
                    }
                },
                {
                    label: 'File Upload', command: () => {
                        goTo('upload')
                    }
                },
                {
                    label: 'Audits',
                    items: [
                        {
                            label: "Prefund Audits", command: () => {
                                goTo('prefund-qc-audits')
                            }
                        },
                        {
                            label: "Post Close Audits", command: () => {
                                goTo('post-close-qc-audits')
                            }
                        },
                        {
                            label: "Servicing Audits", command: () => {
                                goTo('service-audits')
                            }
                        },
                        {
                            label: "Findings", command: () => {
                                goTo('FindingList')
                            }
                        }
                    ]
                },
                {
                    label: 'QC Reporting', command: () => {
                        goTo('reporting')
                    }
                },
                 {
                     label: 'QC Checklist', command: () => {
                         goTo('checklist')
                     }
                 }
            ]);
        }
        else if (isQCAuditor) {
            setAdminItems([
                {
                    label: "Dashboard", command: () => {
                        goTo('.')
                    }
                },
                {
                    label: "QC Work", command: () => {
                        goTo('worklist')
                    }
                },
                {
                    label: 'Audits',
                    items: [
                        {
                            label: "Prefund Audits", command: () => {
                                goTo('prefund-qc-audits')
                            }
                        },
                        {
                            label: "Post Close Audits", command: () => {
                                goTo('post-close-qc-audits')
                            }
                        },
                        {
                            label: "Servicing Audits", command: () => {
                                goTo('service-audits')
                            }
                        },
                        {
                            label: "Findings", command: () => {
                                goTo('FindingList')
                            }
                        }
                    ]
                },
                {
                    label: 'QC Reporting', command: () => {
                        goTo('reporting')
                    }
                },
                {
                    label: 'QC Checklist', command: () => {
                        goTo('checklist')
                    }
                }
            ]);
        }
        else if (isQCValidator) {
            setAdminItems([
                {
                    label: "Validation Work", command: () => {
                        goTo('Validations')
                    }
                }
            ]);
        }else if (isMasterAdmin) {
            setAdminItems([
                {
                    label: "Dashboard", command: () => {
                        goTo('.')
                    }
                },
                {
                    label: 'Audits',
                    items: [
                        {
                            label: "Prefund Audits", command: () => {
                                goTo('prefund-qc-audits')
                            }
                        },
                        {
                            label: "Post Close Audits", command: () => {
                                goTo('post-close-qc-audits')
                            }
                        },
                        {
                            label: "Servicing Audits", command: () => {
                                goTo('service-audits')
                            }
                        },
                        {
                            label: "Findings", command: () => {
                                goTo('FindingList')
                            }
                        }
                    ]
                },
                {
                    label: 'QC Reporting', command: () => {
                        goTo('reporting')
                    }
                },
                {
                    label: 'QC Checklist', command: () => {
                        goTo('checklist')
                    }
                },
                {
                    label: 'Admin',
                    items: [
                        {
                            label: "Users", command: () => {
                                goTo('users')
                            }
                        },
                        {
                            label: "Accounts", command: () => {
                                goTo('accounts')
                            }
                        },
                        {
                            label: "Client Banks", command: () => {
                                goTo('clientbanks')
                            }
                        },
                    ]
                }
            ]);
        }else if(isSecurityAdmin){
            setAdminItems([
                {
                    label: 'Admin',
                    items: [
                        {
                            label: "Users", command: () => {
                                goTo('users')
                            }
                        },
                        // {
                        //     label: "Accounts", command: () => {
                        //         goTo('accounts')
                        //     }
                        // },
                        // {
                        //     label: "Client Banks", command: () => {
                        //         goTo('clientbanks')
                        //     }
                        // },
                    ]
                }
            ]);
        }
        else {
            setAdminItems([
                {
                    label: "Your Profile", command: () => {
                        goTo('profile')
                    }
                }
            ]);
        }

    }, [isAccountAdmin, isAccountManager, isQCAdmin, isQCAuditor, isQCManager, isQCValidator, isSysAdmin,isMasterAdmin,isSecurityAdmin,navigate, validRoles]);


    const endHeader = useMemo(() => (
        <div className="flex align-items-center gap-4 pt-2 pb-2">
            <div>
                <span className="ml-4 mr-2 font-normal font-italic">Powered By </span>
                <Image alt="logo" src='/assets/images/loanDNA_logo.jpg' height="24px" className="mr-2"></Image>
            </div>

            <Search />

            {/*@ts-ignore*/}
            <button style={{ all: "unset" }} onClick={(e) => notificationOverlayRef.current.toggle(e)}>
                <i className="pi pi-bell " style={{ fontSize: '1.5rem', color: 'var(--ca-color-2)' }}></i>
            </button>
            <NavLink to={getTenantPath('profile')}>
                <i className="pi pi-user " style={{ fontSize: '1.5rem', color: 'var(--ca-color-2)' }}></i>
            </NavLink>

            <OverlayPanel ref={notificationOverlayRef}>
                <h4>Notifications</h4>
            </OverlayPanel>
        </div>
    ), []);
const startHeader = useMemo(() => (
    <div className="h-5rem" style={{ display: 'flex', alignItems: 'center' }}>
        <Image
            alt="logo"
            src={logoImage ? `data:image/png;base64,${logoImage}` : '/assets/images/ca_logo.png'}
            imageStyle={{ height: "100%", width: "auto", maxWidth: "160px", objectFit: "contain" }}
            className="mr-2"
        />
    </div>
), [logoImage]);
    // const startHeader = useMemo(() => (
    //     <div className="h-5rem">
    //         <Image alt="logo" src='/assets/images/ca_logo.png' style={{ height: "100%" }} className="mr-2"></Image>
    //     </div>
    // ), []);

    return (
        <div>
            <div className="header">
                <Menubar className="pt-0 pb-0"
                    start={startHeader} end={endHeader} />
            </div>
            <div className="nav">
                <Menubar model={adminItems} />
            </div>
        </div>
    )
}